/* eslint-disable */
import getRequest from 'utils/getRequest'
import { getApiUrl } from 'utils/apiBaseUrl'

const path = '/api/reports'
const monitoringPath = '/api/monitoring-reports'
export const getSitesReportsRequest = ({ queryString, pagination, sorting }) => {
  const url = sorting
    ? `${path}/sites?${queryString}&${pagination}&${sorting}`
    : `${path}/sites?${queryString}&${pagination}`
  return getRequest(url)
}

export const getSpeciesReportsRequest = ({ queryStrings, pagination, sorting }) => {
  return getRequest(`${path}/site-species?${queryStrings}&${pagination}&${sorting}`)
}

export const downloadSpeciesReports = () => {
  return getRequest(`${path}/site-species/download`)
}

export const getMonitoringSitesReportsRequest = ({ queryStrings, pagination, sorting }) => {
  const url = sorting
    ? `${monitoringPath}?${queryStrings}&${pagination}&${sorting}`
    : `${monitoringPath}?${queryStrings}&${pagination}`

  return getRequest(url)
}

export const getMonitoringSitesForDownload = (queryStrings, sorting) => {
  const url = sorting
    ? `${monitoringPath}/download?${queryStrings}&${sorting}`
    : `${monitoringPath}/download?${queryStrings}`

  return fetch(url).then((res) => {
    return readAllChunks(res.body)
  })
}

async function readAllChunks(readableStream) {
  const reader = readableStream.pipeThrough(new TextDecoderStream()).getReader()
  const chunks = []

  let done, value
  while (!done) {
    ;({ value, done } = await reader.read())
    if (done) {
      return chunks
    }
    chunks.push(value)
  }
}

export const getSiteForDownload = (queryString) => {
  return fetch(getApiUrl(`/api/reports/sites/download?${queryString}`)).then((res) => {
    return readAllChunks(res.body)
  })
}

export const getSpeciesForDownload = (queryString) => {
  return fetch(getApiUrl(`/api/reports/site-species/download?${queryString}`)).then((res) => {
    return readAllChunks(res.body)
  })
}
